import React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { setVisibilityFilter, resetVisibilityFilter } from '../../../actions/filters';

class TitleFilter extends React.Component {
  state = {
    filter: this.props.visibilityFilter,
  };

  componentWillUnmount() {
    this.props.resetVisibilityFilter();
  }

  handleFilterChange = (event) => {
    let filter = event.currentTarget.value.toLowerCase();
    this.setState({ filter });
    this.props.setVisibilityFilter(filter);
  };

  render() {
    return <InputGroup className='mb-3'>
      <InputGroup.Prepend>
        <InputGroup.Text id='title-filter-addon'><span className='icon icon-filter'></span></InputGroup.Text>
      </InputGroup.Prepend>
      <FormControl
        placeholder={ this.props.placeholder }
        aria-label={ this.props.placeholder }
        aria-describedby='title-filter-addon'
        value={ this.state.filter }
        onChange={ this.handleFilterChange }
        disabled={ this.props.disabled }
      />
    </InputGroup>
  }
};

// Задание значений по умолчанию для пропсов:
TitleFilter.defaultProps = {
  placeholder: gettext('Введите Название, Исполнителя или Композитора')
};

let mapStateToProps = (state) => {
  return {
    visibilityFilter: state.filters.visibilityFilter,
  }
};

export default compose(connect(mapStateToProps, { setVisibilityFilter, resetVisibilityFilter }))(TitleFilter)
